<h2 mat-dialog-title>Repair finished</h2>

<mat-dialog-content>
  <!-- Only what the run did not finish. The counts of what it did said nothing an operator
       acts on; the list below is the part that needs somebody. -->
  <ul class="summary-list" *ngIf="data.idReport.skipped.length || data.statusReport.totals.failed">
    <li class="summary-list__bad" *ngIf="data.idReport.skipped.length">
      <strong>{{ data.idReport.skipped.length }}</strong> id fix{{ data.idReport.skipped.length === 1 ? '' : 'es' }}
      skipped — listed above the table.
    </li>
    <li class="summary-list__bad" *ngIf="data.statusReport.totals.failed">
      <strong>{{ data.statusReport.totals.failed }}</strong> status write{{ data.statusReport.totals.failed === 1 ? '' : 's' }} failed.
    </li>
  </ul>

  <!-- The point of this dialog. Nothing in this application can reverse an NSFPAYMENT import
       into NLS, so these are not a notification: they are outstanding work. -->
  <div class="manual" *ngIf="reversals.length; else noManual">
    <p class="manual__title">
      <mat-icon>priority_high</mat-icon>
      {{ reversals.length }} payment{{ reversals.length === 1 ? '' : 's' }} to check in NLS
    </p>
    <p class="manual__why">
      These were corrected off a returned status. Each may still be standing as NSF in NLS,
      and an NSF import cannot be undone from here — please check each one and reverse the NSF
      where there is one.
    </p>
    <p class="manual__why">
      Find them by <strong>loan, due date and amount</strong>. The payment is not looked up
      automatically: NLS re-issues a payment's reference whenever it is reversed and re-posted,
      so the one recorded at submit time stops matching and a lookup built on it answers
      wrongly often enough to mislead.
    </p>

    <div class="manual__table-wrap">
      <table class="manual__table">
        <thead>
          <tr>
            <th>Loan</th>
            <th>Due date</th>
            <th>Amount</th>
            <th>Was</th>
            <th>Now</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of reversals">
            <td>{{ item.loanNumber }}</td>
            <td class="mono">{{ item.dueDate | date: 'yyyy-MM-dd' }}</td>
            <td class="mono">{{ (item.amountInCents / 100) | currency }}</td>
            <td>{{ item.statusWas }}<span *ngIf="item.returnCodeWas"> ({{ item.returnCodeWas }})</span></td>
            <td>{{ item.statusNow }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <ng-template #noManual>
    <p class="manual manual--clear">
      <mat-icon>check_circle</mat-icon>
      No payment was moved off a return. Nothing to check in NLS.
    </p>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" type="button" *ngIf="reversals.length" (click)="exportReversals()">
    <mat-icon>download</mat-icon>
    Export list
  </button>
  <button mat-flat-button color="primary" type="button" (click)="close()">Done</button>
</mat-dialog-actions>
